import type {RootContent} from 'hast'

export function renderHastNode(node: RootContent, index: number): React.ReactNode {
  if (node.type === 'text') return node.value
  if (node.type === 'element') {
    const className = (node.properties?.className as string[] | undefined)?.join(' ') || undefined
    return (
      <span key={index} className={className}>
        {node.children.map((c, i) => renderHastNode(c as RootContent, i))}
      </span>
    )
  }
  return null
}
